/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortform_ReplacementsInputs */



/**
* | output |
* | --- |
* | "Shortform Replacements" |
*
* @param {Shortform_ReplacementsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform_replacements = /** @type {((inputs?: Shortform_ReplacementsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortform_ReplacementsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacements de formes abrégées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurzformen für Ersetzungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituzioni abbreviate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замена коротких форматов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazos de formato corto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("简短的替代方案")
	if (locale === "ja") return /** @type {LocalizedString} */ ("短縮形の置換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त प्रतिस्थापन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituições de formato abreviado")
	return /** @type {LocalizedString} */ ("Shortform Replacements")
});